import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { downloadCh31PdfLetter } from '../actions/ch31-case-status-details';
import CounselorInfo from './CounselorInfo';

const ApplicationDiscontinuedAlert = ({ resCaseId }) => {
  const dispatch = useDispatch();
  const { loading: isDownloading, error: downloadError } = useSelector(
    state => state?.ch31PdfLetterDownload || {},
  );

  const handleDownload = event => {
    event.preventDefault();

    if (isDownloading) return;

    dispatch(downloadCh31PdfLetter(resCaseId));
  };

  const downloadErrorMessage = downloadError
    ? "We can't download your letter right now. Please try again later."
    : null;

  return (
    <div className="vads-u-margin-y--3">
      <va-alert
        close-btn-aria-label="Close notification"
        status="error"
        visible
      >
        <h2 slot="headline">Your Chapter 31 claim has been discontinued.</h2>
        <p>Your VR&E Chapter 31 claim has been discontinued.</p>
        <p>
          To learn why we discontinued your VR&E Chapter 31 claim, download your
          decision letter.
        </p>
        {downloadErrorMessage ? (
          <p aria-live="assertive" role="alert">
            <strong>Note:</strong> {downloadErrorMessage}
          </p>
        ) : (
          <>
            {isDownloading ? (
              <va-loading-indicator
                label="Loading"
                message="Downloading your letter..."
                set-focus
              />
            ) : (
              <va-link
                download
                filetype="PDF"
                href="#"
                text="Download the VR-58 CH31 Adverse Action Decision Letter"
                onClick={handleDownload}
              />
            )}
          </>
        )}
        <p>If you need more information, contact your counselor.</p>
        <CounselorInfo showCard={false} />
      </va-alert>
    </div>
  );
};

ApplicationDiscontinuedAlert.propTypes = {
  resCaseId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ApplicationDiscontinuedAlert;
